import { CSSProperties, ReactNode, createContext, useContext, useLayoutEffect, useRef, useState } from "react";

const StickyOffsetContext = createContext(0);

type StickyProps = {
  header: ReactNode;
  body: (offset: number) => ReactNode;
  className?: string;
};

export default function Sticky({ header, body, className = "" }: StickyProps) {
  const parentOffset = useContext(StickyOffsetContext);
  const ref = useRef<HTMLDivElement>(null);
  const [headerHeight, setHeaderHeight] = useState(0);
  const offset = parentOffset + headerHeight;

  useLayoutEffect(() => {
    if (!ref.current) return;
    const observer = new ResizeObserver(([entry]) => setHeaderHeight(entry.target.getBoundingClientRect().height));
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className={`flex flex-col ${className}`}>
      <div ref={ref} className="top-sticky-header sticky z-10 bg-white">
        {header}
      </div>
      <StickyOffsetContext.Provider value={offset}>
        <div className="isolate flex flex-col" style={{ "--sticky-header-height": `${offset}px` } as CSSProperties}>
          {body(offset)}
        </div>
      </StickyOffsetContext.Provider>
    </div>
  );
}
